// extracted by mini-css-extract-plugin
export default {"storeTitle":"xuTOmYB1_cANIENImocs","user":"HaRVjRJyXq1lfPZSC_Ut"};